import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import {
  Handlers,
  GetOptions,
  PostOptions,
  PutOptions,
  DeleteOptions
} from './interfaces/request.interfaces';

import { AppConfig } from '../app.config';

// request service
@Injectable()
export class RequestService {

  private apiUrl: string = AppConfig.apiUrl;

  constructor(private httpClient: HttpClient) {
    if (window.location.hostname === 'stagebooking.consentz.com') {
      this.apiUrl = 'https://staging.consentz.com/api/v1';
    }
  }

  public post<TRequestBody, TResponseBody>(options: PostOptions<TRequestBody, TResponseBody>): any {
    return this.httpClient
      .post<TResponseBody>(this.apiUrl + options.url, options.body)
      .subscribe(options.handlers.success, options.handlers.error);
  }

  public get<TResponseBody>(options: GetOptions<TResponseBody>): any {
    return this.httpClient
      .get<TResponseBody>(
        options.url === 'https://www.googleapis.com/calendar/v3/calendars/nbv1oc3qkgrkreuu2469mcd8ss%40group.calendar.google.com/events?key=AIzaSyBb8E1JfMHvaXvcdpm56RKGt_msDuBMnxs' ?
        options.url : this.apiUrl + options.url,
        {params: options.parameters})
      .subscribe(options.handlers.success, options.handlers.error);
  }

  public put<TRequestBody, TResponseBody>(options: PutOptions<TRequestBody, TResponseBody>): any {
    return this.httpClient
      .put<TResponseBody>( this.apiUrl + options.url, options.body)
      .subscribe(options.handlers.success, options.handlers.error);
  }

  public delete<TResponseBody>(options: DeleteOptions<TResponseBody>): any {
    return this.httpClient
      .delete<TResponseBody>(this.apiUrl + options.url, {params: options.parameters})
      .subscribe(options.handlers.success, options.handlers.error);
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/services/request.service.ts